import { cacheKeys } from "@constants/cache-keys";
import { isMockedData } from "@constants/demo";
import { mockedPraxisMixedItemDistribution } from "@constants/demo";
import type { MixedItemDistResponse } from "@memorang/types";
import { useQuery } from "@tanstack/react-query";
import { getMixedItemDistribution } from "api/queries";
import useAppConfigIds from "./useAppConfigIds";
import { useDemoExamStore } from "./useDemoExamStore";

const useMixedItemDist = (enabled = true) => {
	const { collectionId, userId } = useAppConfigIds();
	const demoExam = useDemoExamStore((state) => state.currentExam);

	const { data, isLoading, isRefetching } = useQuery({
		queryKey: [cacheKeys.home, userId, collectionId, demoExam.id],
		queryFn: async () => {
			if (isMockedData) {
				return mockedPraxisMixedItemDistribution.data as unknown as MixedItemDistResponse;
			}
			const result = await getMixedItemDistribution({
				collectionId,
				userId,
			});
			return result;
		},
		enabled: isMockedData || (!!collectionId && !!userId && enabled),
	});

	return { data, isLoading, isRefetching };
};

export default useMixedItemDist;
